import { http } from '@/shared/api/http'

export async function getActiveWeeklyItems() {
  const response = await http.get('/homepage/weekly')
  return response.data
}

export async function getAllWeeklyItems() {
  const response = await http.get('/admin/homepage/weekly')
  return response.data
}

export async function createWeeklyItem(data) {
  const response = await http.post('/admin/homepage/weekly', data)
  return response.data
}

export async function updateWeeklyItem(id, data) {
  const response = await http.put(`/admin/homepage/weekly/${id}`, data)
  return response.data
}

export async function deleteWeeklyItem(id) {
  const response = await http.delete(`/admin/homepage/weekly/${id}`)
  return response.data
}

export async function reorderWeeklyItems(itemOrders) {
  const response = await http.patch('/admin/homepage/weekly/reorder', { itemOrders })
  return response.data
}